import { detectHomoglyph } from '../utils/homoglyph'
import type { ItemRow } from './itemsTable.types'

// Цвет текста категории по уровню доверия парсера (GREEN/YELLOW/RED).
export function namingTextClass(status?: 'GREEN' | 'YELLOW' | 'RED'): string {
  if (status === 'GREEN') return 'text-green-700'
  if (status === 'YELLOW') return 'text-amber-700'
  if (status === 'RED') return 'text-red-600'
  return 'text-gray-700'
}

// Тултип-объяснение к ячейке «Наименование» (почему оно красное/жёлтое) — при
// наведении показывает менеджеру, что именно не так и что делать.
export function namingTitle(row: ItemRow): string | undefined {
  if (row.namingStatus === 'RED') {
    if (detectHomoglyph(row.partNumber).has)
      return '🔴 В артикуле смешаны кириллица и латиница — поправьте партномер слева'
    if (row.dedupCanonical)
      return `🔴 Партномер отличается от каталожного «${row.dedupCanonical}» — проверьте/подставьте`
    if (!row.category.trim())
      return '🔴 Наименование не распознано (нет в справочнике, не подошли правила/бренд) — укажите вручную'
    return '🔴 Категория требует проверки'
  }
  if (row.namingStatus === 'YELLOW') {
    if (row.namingSource === 'brand')
      return '🟡 Категория определена по бренду (не по партномеру) — проверьте'
    if (row.namingSource === 'learned')
      return '🟡 Категория по обученному правилу семейства — проверьте'
    if (row.namingSource === 'description')
      return '🟡 Категория выведена из описания позиции — проверьте'
    return '🟡 Категория предположительная — проверьте'
  }
  return row.category || undefined
}
